import { React, useRef, useState } from "react";
import { Col, Form, Row, Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import _ from "lodash";
import EmptyItemView from "../../../../components/EmptyItemView";
import * as setOffSelectors from "../../../../selectors/set-off";

import clsx from "clsx";
import CustomPriceSpan from "../../../../components/CustomPriceSpan";
import CurrencyInput from "react-currency-input-field";
import Helper from "../../../../utils/Helper";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { getSetOffTotalOutstandingAmountFullText } from "../../../../selectors/set-off";
import { Tooltip as ReactTooltip } from "react-tooltip";
function EPaymentTable({
  data,
  loading,
  setPartAmt,
  partAmt,
  totalValue,
  totalAmount,
  setTotalAmount,
  selectedCurrency,
  depositAmount,
  setDepositAmount,
  isOperatePayment,
  isOperatePaymentCutOff
}) {
  const [checkedItems, setCheckedItems] = useState({});
  const [tooltips, setTooltips] = useState({});
  const [show, setShow] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const tooltipsRef = useRef();
  const handleCheckboxChange = (e, index, total) => {
    setCheckedItems((prevCheckedItems) => {
      const newCheckedItems = { ...prevCheckedItems, [index]: e.target.checked };
      const isChecked = e.target.checked;
      setPartAmt((prevPartAmt) => {
        const totalSum = _.sumBy(_.values(_.omit(partAmt, index)), (item) => {
          return Math.abs(item?.total);
        });

        setTotalAmount(isChecked ? totalSum + Math.abs(total) : totalSum);
        return {
          ...prevPartAmt,
          [index]: {
            total: isChecked ? total : 0,
            negative: total < 0,
          },
        };
      });

      return newCheckedItems;
    });
  };

  const handleSelectAllChange = () => {
    const newCheckedItems = {};
    const newPartAmt = {};
    let totalAmount = 0;

    if (!selectAllChecked) {
      _.forEach(data, (setOff, index) => {
        const total = setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
        if (Math.abs(total) !== 0) {
          newCheckedItems[index] = true;
          newPartAmt[index] = {
            total:  total,
            negative: total < 0,
          };
          totalAmount = totalAmount + Math.abs(total);
        }
      });
    } else {
      _.forEach(data, (setOff, index) => {
        newCheckedItems[index] = false;
        newPartAmt[index] = {
          total: 0,
          negative: false,
        };
      });
      totalAmount = 0;
    }
    setTotalAmount(totalAmount);
    setCheckedItems(newCheckedItems);
    setPartAmt(newPartAmt);
    setSelectAllChecked(!selectAllChecked);
  };

  return (
    <div className={"responsive-table-border"}>
      <Table responsive="lg" className="position-relative">
        {!isOperatePayment && (
            <div className={"overlayIsOperate"}>
              {/*<div className={"overlayIsOperateText"}>*/}
              {/*  /!*<p>hi</p>*!/*/}
              {/*  Please Try Again Tomorrow. Our Cut off time is {isOperatePaymentCutOff}.ss*/}
              {/*</div>*/}
            </div>
        )}
        <thead>
        <tr className={"custom-table-setoff-styled"}>
          {/*===== For "CheckBox" ===== */}
          <th style={{width: "30px"}}>
            <Form.Check
                checked={selectAllChecked}
                className="custom-setoff-table-checkbox"
                onChange={handleSelectAllChange}
                disabled={!isOperatePayment}
            />
          </th>
          <th style={{width: 100}}>Date</th>
          <th style={{width: 120}}>Reference No</th>
          <th style={{width: 100}}>Stock Code</th>
          <th style={{width: 150}}>Stock Name</th>
          <th style={{width: 100}}>Amount</th>
          <th style={{width: 100}}>Accrued Interest</th>
          <th style={{width: 100}}>Total Amount</th>
          <th style={{width: 100}}>Balance Amount</th>
          {/*===== End for For "CheckBox" ===== */}
          {/*===== For "Part Amt" ===== */}
          <th style={{width: "200px"}}>Selected Amount</th>
          {/*===== End for "Part Amt" ===== */}
        </tr>
        </thead>
        <tbody>
        {!_.isEmpty(data) ? (
            _.map(data, (setOff, index) => {
              const refNo = setOffSelectors.getSetOffContractReference(setOff);
              const date = setOffSelectors.getSetOffTransactionDate(setOff);
              const stockCode = setOffSelectors.getSetOffStockCode(setOff);
              const stockName = setOffSelectors.getSetOffStockName(setOff);
              // const balAmount = setOffSelectors.getSetOffTotalOutstandingAmountFullText(setOff);
              const balAmount = setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
              const amount = setOffSelectors.getSetOffOutstandingAmountFullText(setOff);

              const accrueInterest = setOffSelectors.getSetOffAccrueInterestFullText(setOff);
              const total = setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
              const totalFullText = setOffSelectors.getSetOffTotalOutstandingBalanceFullText(setOff);
              const totalOutstandingAmount = setOffSelectors.getSetOffTotalOutstandingAmountFullText(setOff);

              return (
                  <tr
                      key={index}
                      className={clsx({
                        ["disabled"]: Math.abs(total) <= 0,
                      })}
                      onClick={(e) => {
                        if (Math.abs(total) <= 0) {
                          tooltipsRef.current?.open({
                            position: {
                              x: e.clientX,
                              y: e.clientY,
                            },
                            place: "bottom",
                            content: "The balance is less than 0.",
                          });
                        }
                      }}
                      onMouseEnter={(e) => {
                        if (Math.abs(total) <= 0) {
                          tooltipsRef.current?.open({
                            position: {
                              x: e.clientX,
                              y: e.clientY,
                            },
                            place: "bottom",
                            content: "The balance is less than 0.",
                          });
                        }
                      }}
                      onMouseLeave={(e) => {
                        tooltipsRef.current?.close();
                      }}
                  >
                    <td style={{width: "30px"}}>
                      {/*<Form.Check*/}
                      {/*  checked={_.get(partAmt, [index, "total"], 0) > 0}*/}
                      {/*  className="custom-setoff-table-checkbox"*/}
                      {/*  readOnly*/}
                      {/*/>*/}
                      <Form.Check
                          checked={checkedItems[index]}
                          className="custom-setoff-table-checkbox"
                          onChange={(e) => handleCheckboxChange(e, index, balAmount)}
                      />
                    </td>
                    <td style={{width: 100}}>{date}</td>
                    <td style={{width: 120}}>{refNo}</td>
                    <td style={{width: 100}}>{stockCode ?? '-'}</td>
                    <td style={{width: 150}}>{stockName ?? '-'}</td>
                    <td style={{width: 100}}>{amount}</td>
                    <td style={{width: 100}}>{accrueInterest}</td>
                    <td style={{width: 100}}>{totalOutstandingAmount}</td>
                    <td style={{width: 100}}>{totalFullText}</td>
                    <td style={{width: 200}}>
                      <CurrencyInput
                          id="input-example"
                          name="input-name"
                          placeholder="Please enter a number"
                          className={clsx("custom-setoff-table-input")}
                          value={_.get(partAmt, [index, "total"], 0)}
                          // prefix={selectedCurrency?.text + " "}
                          disabled={Math.abs(total) <= 0 || !isOperatePayment}
                          max={`${Math.abs(balAmount)}`}
                          min={0}
                          decimalScale={2}
                          decimalSeparator="."
                          groupSeparator=","
                          onValueChange={(value, name, values) => {
                            const totalSum = _.sumBy(_.values(_.omit(partAmt, index)), (item) => {
                              return Math.abs(item?.total);
                            });
                            setCheckedItems((prevCheckedItems) => {
                              return {
                                ...prevCheckedItems,
                                [index]: Math.abs(value) !== undefined && Math.abs(value) !== 0
                              };
                            });
                            setTotalAmount(
                                _.ceil(
                                    totalSum +
                                    (Math.abs(value) > Math.abs(total) ? Math.abs(total) : Math.abs(value)),
                                    2,
                                ),
                            );
                            setPartAmt((prev) => {
                              let newValue = value;
                              if (Math.abs(newValue) > Math.abs(balAmount)) {
                                newValue = Math.abs(balAmount)
                              }


                              if (newValue === undefined) {
                                newValue = "0";
                              }
                              // if (value === undefined) {
                              //   return {
                              //     ...prev,
                              //     [index]: {
                              //       total: 0,
                              //       negative: total < 0,
                              //     },
                              //   };
                              // }
                              //
                              // if (_.includes(value, ".")) {
                              //   return {
                              //     ...prev,
                              //     [index]: {
                              //       total: value,
                              //       negative: total < 0,
                              //     },
                              //   };
                              // }
                              //
                              // const abs = _.floor(value, 2) * 100;

                              return {
                                ...prev,
                                [index]: {
                                  total: newValue,
                                  negative: total < 0,
                                },
                              };
                            });
                          }}
                      />
                    </td>
                  </tr>
              );
            })
        ) : (
            <tr>
              <td colSpan={10}>
                <EmptyItemView/>
              </td>
            </tr>
        )}
        </tbody>
        <tfoot className="setoff-table-footer">
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <div className="d-flex justify-content-between">Selected Amount</div>
          </th>
          <th>
              <span>
                {selectedCurrency?.text} <CustomPriceSpan value={totalValue}></CustomPriceSpan>
              </span>
          </th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <div className="d-flex justify-content-between">Deposit into Trust</div>
          </th>
          <th>
            <CurrencyInput
                id="input-example"
                name="input-name"
                placeholder="Please enter a number"
                className={clsx("custom-setoff-table-input text-bold-600")}
                value={depositAmount}
                decimalScale={2}
                decimalSeparator="."
                groupSeparator=","
                // prefix={selectedCurrency?.text + " "}
                onValueChange={(value) => {
                  setDepositAmount(value);
                }}
                decimalsLimit={2}
                min={0}
            />
          </th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <div className="d-flex justify-content-between text-bold-600">Total Payment</div>
          </th>
          <th>
              <span className="text-bold-600">
                {selectedCurrency?.text}{" "}
                <CustomPriceSpan value={Number(totalValue) + Number(depositAmount)}></CustomPriceSpan>
              </span>
          </th>
        </tr>
        </tfoot>
      </Table>
      {/*<Overlay*/}
      {/*    target={tooltips}*/}
      {/*    rootClose={true}*/}
      {/*     rootCloseEvent="mousedown"*/}
      {/*    onHide={(e) => {*/}
      {/*        setTooltips('');*/}
      {/*        setShow(false);*/}
      {/*    }}*/}
      {/*    hasDoneInitialMeasure={true}*/}
      {/*    show={show}*/}
      {/*    flip*/}
      {/*    placement="top"*/}
      {/*    transition={true}*/}
      {/*>*/}
      {/*  <Tooltip id="overlay-example" >*/}
      {/*    My Tooltip*/}
      {/*  </Tooltip>*/}
      {/*</Overlay>*/}
      <ReactTooltip ref={tooltipsRef} className="tooltip-info" variant="info"></ReactTooltip>
      <LoadingOverlay loading={loading}></LoadingOverlay>
    </div>
  );
}

export default EPaymentTable;
